module.exports = __webpack_public_path__ + "static/media/practice_version_2.49e13f53.png";